import React from "react";
import {Link} from "react-router-dom";

const FarmyBreadcrumbs = (props) => {
  const defaultSeparator = " > ";
  const {breadcrumbs, className} = props;
  const Separator = props?.Separator || <span>{defaultSeparator}</span>;

  return <div className={className || ""}>{breadcrumbs?.length && <div className="farmy-breadcrumbs">
    {breadcrumbs.map((breadcrumb, index) => (
      <div className="farmy-breadcrumb display-inline margin-left-3" key={breadcrumb?.id}>
        {index > 0 ? Separator : null}

        <Link
          to={breadcrumb.seo_url}
          className="text-decoration-underline margin-left-3 text-strong"
        >
          {breadcrumb.name}
        </Link>
      </div>))}
  </div>}</div>;
};

export default FarmyBreadcrumbs;
